import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import biodoc from "../../Assets/Projects/biodoc.webp";
import drawingview from "../../Assets/Projects/drawingView.gif";
import happyweb from "../../Assets/Projects/happyweb.webp";
import impokeyboard from "../../Assets/Projects/impokeyboard.webp";
import mywords from "../../Assets/Projects/myWords.gif";
import signverify from "../../Assets/Projects/signVerify.png";

function Projects() {
  return (
      <div id="projects">
    <Container fluid className="project-section">
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
                imgPath={biodoc}
                title="BioDoc - Fast Reading App"
                description="BioDoc helps you read faster. Paste text into the app and start reading efficiently. You can also send readings to your Kindle with one click."
                demo={"https://apps.apple.com/gb/app/biodoc-fast-reading/id1644751830"}
                tech={"iOS - React Native"}
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
                imgPath={impokeyboard}
                title="ImpoKeyboard - Custom Game Keyboard App"
                description="ImpoKeyboard is a custom keyboards app that is designed for amoug us game. You can customize your keyboard to ease chatting in the game"
                demo={"https://play.google.com/store/apps/details?id=amonguskeyboard.amongkeyboard.impokeyboard"}
                tech={"Android - Java"}
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
                imgPath={happyweb}
                title="HappyWeb - Birthday Website App"
                description="It is a android application to create a website that celebrates the birthday of the person you love"
                github="https://github.com/tolunaykan/Happy-Birthday-Website-Maker"
                demo={"https://play.google.com/store/apps/details?id=com.zisantolunay.happybirthday"}
                tech={"Android - Java"}
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={drawingview}
              title="DrawingView Library"
              description="Simple Android library that provides a drawing view and tools. It includes a canvas, brush, eraser, etc."
              github="https://github.com/tolunaykan/DrawingView-Library-Android"
              tech={"Android - Java"}
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
                imgPath={mywords}
                title="MyWords - Learn Language App"
                description="Simple Android app that teaches people languages easily. Add the word you want to your list with the corresponding language in the foreign language and practice until you learn. While considering words, that picture will come to your mind, and you will be able to form sentences quickly."
                github="https://github.com/tolunaykan/MyWords-Learn-Language"
                demo={"https://play.google.com/store/apps/details?id=com.tolunaykandirmaz.mywords"}
                tech={"Android - Java"}
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
                imgPath={signverify}
                title="SignVerify - Signature Validation App"
                description="Signature validation app that uses a pre-trained deep learning model. It detects the signature and its position. Then, it validates whether the signature is valid by comparing the user's saved signature."
                github="https://github.com/tolunaykan/SignVerify"
                tech={"Android - Java"}
            />
          </Col>

        </Row>
      </Container>
    </Container></div>
  );
}

export default Projects;
